var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{attrs:{"editing-object":_vm.milkTeaInfo,"is-dialog":false,"schema":_vm.schemas},on:{"submit":_vm.updateSetting}})
}
var staticRenderFns = []

export { render, staticRenderFns }